import ExchangesModel from 'models/ExchangesModel';

ExchangesStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  ExchangesStore.dispatchCallback,
);
ExchangesStore.users = [];
ExchangesStore.allExchanges = [];
ExchangesStore.allUsers = [];
ExchangesStore.allBids = [];
ExchangesStore.allOtherShiftDetails = [];
ExchangesStore.myAcceptedShiftExchanges = [];

ExchangesStore.onExchangesHandler = function (exchangesData, response) {
  ExchangesStore.reset(response.data.advertisements);
  ExchangesStore.users = response.data.users;
  BidsStore.reset(response.data.bids);
  ExchangesStore.others_shift_details = response.data.others_shift_details;
  ExchangesStore.trigger('exchanges:load:success', exchangesData, response);
};

ExchangesStore.onExchangesError = function (error) {
  ExchangesStore.trigger('exchanges:load:error', error);
};

ExchangesStore.onAllExchangesHandler = function (exchangesData, response) {
  ExchangesStore.allExchanges = [];
  const len = response.data.advertisements.length;
  for (let i = 0; i < len; i++) {
    ExchangesStore.allExchanges.push(new ExchangesModel(response.data.advertisements[i]).present());
  }
  ExchangesStore.allUsers = response.data.users;
  ExchangesStore.allBids = response.data.bids;
  ExchangesStore.allOtherShiftDetails = response.data.others_shift_details;
  ExchangesStore.allExchanges.map((exchange) => {
    const details = ExchangesStore.getAllExchangeShiftDetails(exchange.shift_id);
    if (!Utils.isNotDefined(details)) {
      exchange.shift_details = details;
    }
  });
  ExchangesStore.parseOutMyAcceptedExchanges();
  ExchangesStore.trigger('all:exchanges:load:success', response);
};

ExchangesStore.parseOutMyAcceptedExchanges = function () {
  ExchangesStore.myAcceptedShiftExchanges = [];
  ExchangesStore.allExchanges.map((exchange) => {
    if (
      exchange.user_id == Utils.getCoreUser().id
      && !Utils.isNotDefined(exchange.accepted_user_id)
    ) {
      const details = ExchangesStore.getAllExchangeShiftDetails(exchange.accepted_shift_id);
      if (!Utils.isNotDefined(details)) {
        exchange.shift_details = details;
      }
      ExchangesStore.myAcceptedShiftExchanges.push(exchange);
    }
  });
};

ExchangesStore.getMyAcceptedShiftExchanges = function () {
  return ExchangesStore.myAcceptedShiftExchanges;
};

ExchangesStore.getMyAcceptedShiftExchangesByDate = function (date) {
  const len = ExchangesStore.myAcceptedShiftExchanges.length;
  for (let i = 0; i < len; i++) {
    const exchange = ExchangesStore.myAcceptedShiftExchanges[i];
    if (
      !Utils.isNotDefined(exchange.shift_details)
      && moment(exchange.shift_details.start_time)
        .tz(exchange.shift_details.time_zone)
        .format('YYYY-M-D') == moment(date).format('YYYY-M-D')
    ) {
      return exchange;
    }
  }
  return null;
};

ExchangesStore.onAllExchangesError = function (error) {
  // ExchangesStore.trigger('exchanges:load:error', response);
};

ExchangesStore.addAllBids = function (bids) {
  bids.map((bid) => {
    ExchangesStore.allBids.push(bid);
  });
};

ExchangesStore.removeAllBids = function (bid) {
  const len = this.allBids.length;
  for (let i = 0; i < len; i++) {
    if (this.allBids[i].id == bid.id) {
      this.allBids.slice(i, 1);
      break;
    }
  }
};

ExchangesStore.getAllExchangeUsers = function () {
  return ExchangesStore.users;
};

ExchangesStore.getAdvertisementByExchangeID = function (exchange_id) {
  let data = {};
  const len = ExchangesStore.allExchanges.length;
  for (let i = 0; i < len; i++) {
    if (ExchangesStore.allExchanges[i].id == exchange_id) {
      data = ExchangesStore.allExchanges[i];
      break;
    }
  }
  return data;
};

ExchangesStore.getExchangeUser = function (id) {
  let data = {};
  ExchangesStore.allUsers.map((d) => {
    if (d.id && d.id === id) {
      data = d;
    }
  });
  return data;
};

ExchangesStore.getAllExchangesUntilTheEndOfTime = function () {
  return ExchangesStore.allExchanges;
};

ExchangesStore.getAllExchanges = function (startDate, endDate) {
  if (Utils.isNotDefined(startDate)) {
    startDate = moment(Utils.getCurrentDate())
      .startOf('month')
      .format();
  }

  if (Utils.isNotDefined(endDate)) {
    endDate = moment(startDate)
      .endOf('month')
      .format();
  }

  const data = ExchangesStore.allExchanges;
  data.map((exchange) => {
    const details = ExchangesStore.getAllExchangeShiftDetails(exchange.shift_id);
    if (!Utils.isNotDefined(details)) {
      exchange.shift_details = details;
    }
  });

  const rtnData = [];
  data.map((obj) => {
    if (
      !Utils.isNotDefined(startDate)
      && !Utils.isNotDefined(endDate)
      && !Utils.isNotDefined(obj.shift_details)
      && moment(obj.shift_details.start_time)
        .tz(obj.shift_details.time_zone)
        .isBetween(startDate, endDate)
    ) {
      rtnData.push(obj);
    }
  });
  return rtnData;
};

ExchangesStore.getAllExchangeDetails = function () {
  const len = ExchangesStore.others_shift_details.length;
  const data = [];
  for (let i = 0; i < len; i++) {
    data.push(ExchangesStore.others_shift_details[i]);
  }
  return data.present();
};

ExchangesStore.getAllExchangeByID = function (id) {
  const len = ExchangesStore.allExchanges.length;
  const data = [];
  for (let i = 0; i < len; i++) {
    if (ExchangesStore.allExchanges[i].id == id) {
      return ExchangesStore.allExchanges[i];
    }
  }
  return null;
};

ExchangesStore.getAllExchangesRequests = function () {
  let data = {};
  this.models.map((d) => {
    if (d.attributes.data.exchange_requests) {
      data = d.attributes.data.exchange_requests;
    }
  });
  return data.present();
};

ExchangesStore.getAllExchangeByShiftId = function (id) {
  let data = {};
  const len = this.allExchanges.length;
  for (let i = 0; i < len; i++) {
    if (this.allExchanges[i].shift_id == id) {
      data = this.allExchanges[i];
      break;
    }
  }

  return data;
};

ExchangesStore.getAllBidsById = function (id) {
  let data = {};
  const len = this.allBids.length;
  for (let i = 0; i < len; i++) {
    if (this.allBids[i].id == id) {
      data = this.allBids[i];
      break;
    }
  }
  return data;
};

ExchangesStore.getExchangeByAcceptedShiftId = function (id) {
  let data = {};
  const len = this.allExchanges.length;
  for (let i = 0; i < len; i++) {
    if (this.allExchanges[i].accepted_shift_id == id) {
      data = this.allExchanges[i];
      break;
    }
  }
  return data;
};

ExchangesStore.getExchangeByShiftId = function (id) {
  let data = {};
  const len = this.allExchanges.length;
  for (let i = 0; i < len; i++) {
    if (this.allExchanges[i].shift_id == id) {
      data = this.allExchanges[i];
      const details = ExchangesStore.getAllExchangeShiftDetails(this.allExchanges[i].shift_id);
      if (!Utils.isNotDefined(details)) {
        data.shift_details = details;
      }
      if (Utils.isNotDefined(data.shift_details)) {
        data.shift_details = ShiftStore.getAllShiftsByShiftId(this.allExchanges[i].shift_id);
      }
      break;
    }
  }
  return data;
};

ExchangesStore.getAllExchangeShiftDetails = function (id) {
  const len = ExchangesStore.allOtherShiftDetails.length;
  let data;
  for (let i = 0; i < len; i++) {
    if (ExchangesStore.allOtherShiftDetails[i].id === id) {
      data = ExchangesStore.allOtherShiftDetails[i];
      break;
    }
  }
  return data;
};

ExchangesStore.getAllBidsByExchangeID = function (id) {
  const bids = [];
  const len = ExchangesStore.allBids.length;
  for (let i = 0; i < len; i++) {
    if (parseInt(ExchangesStore.allBids[i].exchange_id, 10) === parseInt(id, 10)) {
      bids.push(ExchangesStore.allBids[i]);
    }
  }
  return bids;
};

ExchangesStore.getExchangeShiftDetails = function (id) {
  const len = ExchangesStore.others_shift_details.length;
  let data;
  for (let i = 0; i < len; i++) {
    if (ExchangesStore.others_shift_details[i].id === id) {
      data = ExchangesStore.others_shift_details[i];
      break;
    }
  }
  return data;
};

ExchangesStore.getExchangeShiftDetailsByShiftId = function (id) {
  const len = ExchangesStore.allOtherShiftDetails.length;
  let data;
  for (let i = 0; i < len; i++) {
    const shift = ExchangesStore.allOtherShiftDetails[i];
    if (parseInt(shift.id, 10) === parseInt(id, 10)) {
      data = shift;
      break;
    }
  }
  return data;
};

ExchangesStore.removeExchangeShiftDetails = function (shiftID, exchangeID) {
  const len = ExchangesStore.allExchanges.length;

  const shift = ShiftStore.get(shiftID);

  for (let i = 0; i < len; i++) {
    if (parseInt(ExchangesStore.allExchanges[i].shift_id, 10) === parseInt(shiftID, 10)) {
      ExchangesStore.allExchanges.splice(i, 1);
      break;
    }
  }
};

ExchangesStore.onAdvertisementsPostHandler = function (model, response) {
  ShiftStore.addExchangeToShift(response);
  ExchangesStore.trigger('exchanges:post:advertisment:success', response, model.collection);
};

ExchangesStore.onAdvertismentsPostError = function (collection, response) {
  ExchangesStore.trigger('exchanges:post:advertisment:error', response);
};

ExchangesStore.onCancelExchangeSuccess = function (collection, response, options) {
  if (!Utils.isNotDefined(options) && !Utils.isNotDefined(options.data)) {
    collection = options.data.details;
  }
  ExchangesStore.trigger('exchanges:cancel:advertisment:success', collection, response);
};

ExchangesStore.onCancelExchangeError = function (collection, response) {
  ExchangesStore.trigger('exchanges:cancel:advertisment:error', collection, response);
};

ExchangesStore.onBidAcceptedSuccess = function (collection, response, exchange) {
  ExchangesStore.trigger('exchanges:bid:advertisment:success', collection, response, exchange);
};

ExchangesStore.onBidAcceptedError = function (collection, response) {
  ExchangesStore.trigger('exchanges:bid:advertisment:error', collection, response);
};
